export const parseTime = (time: number) => {
	let hour = parseInt((time / 100).toString());
	const mins = time % 100;
	const meridian = hour >= 12 ? "PM" : "AM";
	if (hour >= 13) hour -= 12;
	return `${hour <= 9 ? `0${hour}` : hour}:${mins ? mins : "00"} ${meridian}`;
};
